<template>
  <v-container>
    <v-row>
      <v-col class="text-right">
        <v-btn @click="getJSON" class="mx-2" color="primary" rounded
          >JSON <v-icon>mdi-download</v-icon></v-btn
        >
        <v-btn @click="getCSV" class="mx-2" color="primary" rounded
          >CSV <v-icon>mdi-download</v-icon></v-btn
        >
        <v-btn @click="getHTML" class="mx-2" color="primary" rounded
          >HTML <v-icon>mdi-download</v-icon></v-btn
        >
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <div v-for="artefact of artefacts" :key="artefact">
          <h3>{{ artefact }}</h3>
          <ul>
            <li
              v-for="(item, index) of releaseNote.changes[artefact]"
              :key="index"
            >
              {{ item.parsed }}
            </li>
          </ul>
        </div>
      </v-col>
    </v-row>
  </v-container></template
>

<script>
export default {
  name: 'ReleaseNote',
  props: {
    releaseNote: {
      type: Object,
      required: true
    }
  },
  computed: {
    artefacts() {
      return Object.keys(this.releaseNote.changes);
    }
  },
  methods: {
    download(data, format) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `release-${this.releaseNote.releases.newest.name}.${format}`
      );
      document.body.appendChild(link);
      link.click();
    },
    getJSON() {
      this.download(JSON.stringify(this.releaseNote), `json`);
    },
    getHTML() {
      let buff = `<html><head><title>${this.releaseNote.releases.newest.name}</title></head><body>`;
      buff += `<h1>Changes between ${this.releaseNote.releases.oldest.name} and ${this.releaseNote.releases.newest.name}</h1>`;
      Object.entries(this.releaseNote.changes).forEach(([repo, messages]) => {
        buff += `<h3>${repo}</h3>`;
        buff += `<ul>`;
        messages.forEach(m => {
          buff += `<li>${m.parsed}</li>`;
        });
        buff += `</ul>`;
      });
      buff += `</body></html>`;
      this.download(buff, `html`);
    },
    getCSV() {
      const universalBOM = '\uFEFF';
      const SEPARATOR = ';';
      const items = [];
      // We can go check release deployments by Release id

      const releaseName = this.releaseNote.releases.newest.name;
      const releaseId = this.releaseNote.releases.newest.id;
      const envs = this.releaseNote.releases.newest.deployments;
      Object.entries(this.releaseNote.changes).forEach(([k, v]) => {
        v.forEach(c => {
          items.push({
            releaseName,
            releaseId,
            worker: k,
            ...envs,
            ...c
          });
        });
      });
      const header = Object.keys(items[0]);
      const csv = [
        header.join(SEPARATOR), // header row first
        ...items.map(row =>
          header.map(fieldName => row[fieldName]).join(SEPARATOR)
        )
      ].join('\r\n');

      this.download(`${universalBOM}${csv}`, `csv`);
    }
  }
};
</script>

<style></style>
